import React, {useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations'
import DemandOffersOfferService from "services/DemandOffersOfferService";
import Loading from "components/Loading";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import moment from "moment/moment";
import DateFormats from "constants/DateFormats";
import GridBlock from "components/GridBlock";
import {makeStyles} from "@material-ui/styles";
import SingleButton from "components/popup/components/SingleButton";
import {getUserFullNameWithEmailAndDeputy} from "libs/userNameGetter";
import WorkableIconDownloadButton from "components/button/WorkableIconDownloadButton";
import {RoundType} from "constants/RoundType";
import {Typography} from "@material-ui/core";
import DemandAdditionalOffersOfferService from "services/DemandAdditionalOffersOfferService";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";

const useStyle = makeStyles(theme => ({
    lpColumn: {
        width: 200
    },
    dateColumn: theme.components.table.dateTimeColumn,
    buttonColumn: theme.components.table.buttonColumn,
}))

export const getConfig = (demandId, stageId, supplierId, roundType, positionId) => ({demandId, stageId, supplierId, roundType, positionId})

function SnapshotListPopup(
    {
        onClose,
        config
    }) {
    const classes = useStyle();
    const [snapshotList, setSnapshotList] = useState(null);
    const [workingId, setWorkingId] = useState(null);
    const stageTr = useContext(OfferStageTranslationsContext);

    useEffect(() => {
        let promise;
        switch (config.roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.getSnapshots(config.demandId, config.stageId, config.supplierId);
                break;
            case RoundType.ADDITIONAL_OFFERS:
                promise = DemandAdditionalOffersOfferService.getSnapshots(config.demandId, config.stageId, config.positionId, config.supplierId);
                break;
            case RoundType.AUCTION:
                promise = DemandOffersAuctionService.getSnapshots(config.demandId, config.stageId, config.positionId, config.supplierId);
                break;
            default:
                throw new Error("Unknown roundType: " + config.roundType);
        }
        promise.then((resp) => {
            if (resp)
                setSnapshotList(resp);
            else
                onClose();
        })
        // eslint-disable-next-line
    }, [])


    const downloadSnapshot = (snapshotId) => {
        setWorkingId(snapshotId);

        let promise;
        switch (config.roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.downloadSnapshot(config.demandId, config.stageId, snapshotId, config.supplierId)
                break;
            case RoundType.ADDITIONAL_OFFERS:
                promise = DemandAdditionalOffersOfferService.downloadSnapshot(config.demandId, config.stageId, config.positionId, snapshotId, config.supplierId);
                break;
            case RoundType.AUCTION:
                promise = DemandOffersAuctionService.downloadSnapshot(config.demandId, config.stageId, config.positionId, snapshotId, config.supplierId);
                break;
            default:
                throw new Error("Unknown roundType: " + config.roundType);
        }
        promise.finally(() => setWorkingId(null))
    }


    return (
        <Dialog
            open
            title={Tr('change_history')}
            titleCentered
            maxWidth='lg'
            onClose={onClose}
            dialogActions={<SingleButton
                justify='flex-end'
                label={Tr('close')}
                onClick={onClose}/>}
        >
            {
                !snapshotList ? <Loading/> : <GridBlock
                    column
                    alignItems='center'
                >
                    <SimpleTable
                        headers={
                            [
                                Tr('date'),
                                Tr('author'),
                                Tr('signature'),
                                Tr('offer_status'),
                                ''
                            ]
                        }
                        items={
                            snapshotList.map((elem, i, arr) => ([
                                <>
                                    {moment(elem.offerSubmitDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}
                                    {elem.offerPlacedInTime && <Typography variant="body2">({stageTr("offer_placed_in_time")})</Typography>}
                                </>,
                                getUserFullNameWithEmailAndDeputy(elem.author),
                                <>
                                    {elem.digitalSignature ? Tr('yes') : Tr('no')}
                                    {!!elem.digitalSignatureDate && <Typography
                                        variant="body2">({moment(elem.digitalSignatureDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)})</Typography>}
                                </>,
                                elem.offerStatus,
                                !elem.empty && <WorkableIconDownloadButton onClick={() => downloadSnapshot(elem.identity)} disabled={!!workingId}
                                                            working={workingId === elem.identity}/>
                            ]))
                        }
                        columnClasses={[
                            classes.lpColumn,
                            undefined,
                            classes.lpColumn,
                            classes.dateColumn,
                            classes.buttonColumn
                        ]}
                    />

                    {snapshotList.length === 0 && <Typography>{Tr('empty_history')}</Typography>}

                </GridBlock>
            }

        </Dialog>
    )
}

SnapshotListPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    config: PropTypes.shape({
        demandId: PropTypes.string.isRequired,
        stageId: PropTypes.string.isRequired,
        supplierId: PropTypes.number,
        roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired,
        positionId: PropTypes.number,
    })
}

export default SnapshotListPopup;
